import React, { useEffect, useState } from 'react';
import FacebookPixel from 'react-facebook-pixel';
import RedditPixel from 'react-reddit-pixel';
import ReactGA from 'react-ga4';
import { useDispatch, useSelector } from 'react-redux';
import { selectWebp } from '../ui/uiSlice';
import { sendAnalyticsEvents } from '../../analytics/common';
import { EVENTS } from '../../analytics/events';
import { setAmplitudeUserProperties } from '../../analytics/amplitude';
import { setLandingType } from '../plans/plansSlice';
import {
  isAndroid,
  isDesktop,
  isIOS,
  osName,
  osVersion,
} from 'react-device-detect';
import { setEventDataList } from '../events/eventsSlice';
import {
  appendLink,
  logoImagesLinks,
  logoWebpImagesLinks,
  plansImagesLinks,
} from '../../helper/utils';
import { queryParser } from 'onboarding-initialization';
import {
  selectUserUuid,
  getPaymentSettings,
  getUserInfo,
  selectPaymentSettingsStatus,
} from '../signup/signupSlice';
import { FB_PIXEL_ID } from '../../analytics/facebook';
import { setLoader } from '../loader/loaderSlice';

const REACT_APP_GOOGLE_TRACKING_ID = process.env.REACT_APP_GOOGLE_TRACKING_ID;

const RemarketingAuth = (props) => {
  const dispatch = useDispatch();
  const [eventParams, setEventParams] = useState(null);
  const userUuid = useSelector(selectUserUuid);
  const status = useSelector(selectPaymentSettingsStatus);
  const isWebp = useSelector(selectWebp);

  useEffect(() => {
    if (eventParams) return;

    const {
      location: { pathname },
      history: {
        location: { search },
      },
    } = props;

    const landingParam = pathname.replace(/\//g, '');
    const { fbclid, gclid, t, ...utms } = queryParser(search);
    const facebookUtm = fbclid ? 'facebook' : null;
    const appDomain = `${window.location.origin}${
      landingParam.length ? `/${landingParam}` : ''
    }`;
    const utmSource = utms.utm_source || facebookUtm || 'organic';
    const landingType = landingParam.length ? landingParam : 'fullPrice';
    utms.utm_source = utmSource;

    if (t) {
      dispatch(getUserInfo(t));
      dispatch(getPaymentSettings(t));
    } else {
      props.history.push('/');
    }

    landingType.length && dispatch(setLandingType(landingType));

    const localEventsData = {
      landing_type: `pairs_${landingType}`,
      app_domain: appDomain,
      app_name: 'Family-Locator',
      landingType,
      appDomain,
      Remarketing: landingType,
      appName: 'Family-Locator',
      fbclid,
      gclid,
      utm: utms,
      utm_source: utmSource,
      os: `${osVersion} ${osName}`,
    };

    const userProperties = {
      AppDomain: appDomain,
      OSDevice: `${
        isDesktop ? 'desktop' : isIOS ? 'iOS' : isAndroid ? 'Android' : osName
      }`,
    };

    dispatch(setEventDataList(localEventsData));
    setAmplitudeUserProperties(userProperties);
    setEventParams(localEventsData);
  }, [dispatch, eventParams, props]);

  useEffect(() => {
    if (!eventParams) return;
      sendAnalyticsEvents(EVENTS.sessionStart, eventParams);
      sendAnalyticsEvents(EVENTS.onboardingStarted, eventParams);
  }, [eventParams]);

  useEffect(() => {
    if (!userUuid) return;
    FacebookPixel.init(FB_PIXEL_ID, { external_id: userUuid });
    FacebookPixel.pageView();

    RedditPixel.init('t2_w1gr13ev',{"optOut":false,"useDecimalCurrencyValues":true,"externalId":userUuid});
    RedditPixel.pageVisit();
  }, [userUuid]);

  useEffect(() => REACT_APP_GOOGLE_TRACKING_ID && ReactGA.initialize(REACT_APP_GOOGLE_TRACKING_ID), []);

  useEffect(() => {
    plansImagesLinks.map((href) => appendLink(href));
    if (isWebp) {
      logoWebpImagesLinks.map((href) => appendLink(href));
    } else {
      logoImagesLinks.map((href) => appendLink(href));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setLoader(true));
    return () => dispatch(setLoader(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (status && userUuid) {
      props.history.push(status === 'success' ? '/checkout' : '/');
    }
  }, [status, userUuid, props]);

  return <></>;
};

export default RemarketingAuth;
